/* ws-journal.js: Journal article enhancements. 2026-10-07 PST.
   1. Builds the table of contents from the article body H2 and H3 headings (and gives each an id).
   2. Copy link button (uses the clipboard; falls back to a message).
   3. Marks the current section in the table of contents while the reader scrolls.
   Content is server-rendered; this only adds. No third-party scripts. */
(function () {
  'use strict';
  var root = document.querySelector('[data-ws-article]');
  if (!root) return;

  var slug = function (t) {
    return t.toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 48);
  };

  // ---- table of contents ----
  var prose = root.querySelector('[data-ws-prose]');
  var toc = root.querySelector('[data-ws-toc]');
  if (prose && toc && toc.hidden) {   // fallback only: the server renders the table of contents from the H2 headings when it can
    var heads = Array.prototype.slice.call(prose.querySelectorAll('h2, h3')).filter(function (h) {
      return h.textContent.replace(/\s+/g, ' ').trim().length > 0 && !h.closest('table, blockquote');
    });
    var h2count = heads.filter(function (h) { return h.tagName === 'H2'; }).length;
    if (heads.length >= 3 && h2count >= 2) {
      var list = toc.querySelector('ol');
      var used = {};
      var frag = document.createDocumentFragment();
      heads.forEach(function (h, i) {
        var text = h.textContent.replace(/\s+/g, ' ').trim();
        var id = h.id;
        if (!id) {
          id = 'h-' + (i + 1) + '-' + (slug(text) || 'section');
          while (used[id] || document.getElementById(id)) id += '-x';
          h.id = id;
        }
        used[id] = true;
        var li = document.createElement('li');
        if (h.tagName === 'H3') li.className = 'ws-toc__sub';
        var a = document.createElement('a');
        a.href = '#' + id;
        a.textContent = text.length > 90 ? text.slice(0, 87) + '...' : text;
        li.appendChild(a);
        frag.appendChild(li);
      });
      list.appendChild(frag);
      toc.hidden = false;
      var cols = toc.parentNode; if (cols && cols.classList) cols.classList.remove('ws-art__cols--solo');

    }
  }

  // ---- highlight the current section in the table of contents ----
  if (toc && !toc.hidden && prose && 'IntersectionObserver' in window) {
    var links = {};
    Array.prototype.forEach.call(toc.querySelectorAll('a[href^="#"]'), function (a) { links[a.getAttribute('href').slice(1)] = a; });
    var current = null;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var a = links[e.target.id];
        if (!a) return;
        if (current) current.removeAttribute('aria-current');
        a.setAttribute('aria-current', 'true');
        current = a;
      });
    }, { rootMargin: '-90px 0px -70% 0px' });
    Array.prototype.forEach.call(prose.querySelectorAll('h2[id], h3[id]'), function (h) { if (links[h.id]) io.observe(h); });
  }

  // ---- wide tables scroll inside the column: make them reachable with the keyboard ----
  if (prose) {
    Array.prototype.forEach.call(prose.querySelectorAll('table'), function (tb) {
      if (tb.scrollWidth > tb.clientWidth + 1) { tb.setAttribute('tabindex', '0'); tb.setAttribute('role', 'region'); tb.setAttribute('aria-label', 'Table, scroll sideways to see all columns'); }
    });
  }

  // ---- copy link ----
  var btn = root.querySelector('[data-ws-copy]');
  var msg = root.querySelector('[data-ws-copied]');
  if (btn) {
    btn.hidden = false;
    btn.addEventListener('click', function () {
      var url = btn.getAttribute('data-url') || location.href;
      var done = function (m) { if (msg) msg.textContent = m; };
      try {
        navigator.clipboard.writeText(url).then(function () { done('Link copied.'); }, function () { done('Copy failed. Select the address bar instead.'); });
      } catch (e) { done('Copy failed. Select the address bar instead.'); }
    });
  }
})();
